module.exports = __webpack_public_path__ + "static/img/image058.864dd04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image058.png
// module id = a0ue
// module chunks = 1